import { render, staticRenderFns } from "./CPopUp.vue?vue&type=template&id=32eadb88&"
import script from "./CPopUp.vue?vue&type=script&lang=ts&"
export * from "./CPopUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports